const Consent = Object.freeze({
  ANALYTICS: 'analytics',
  STORAGE: 'storage',
  MARKETING: 'marketing'
} as const)

export type Consent = (typeof Consent)[keyof typeof Consent];
export default Consent
